export const getSelectedCompanies = (userCompanies, selectedCompanies) => {
  let companyArray = [];

  if (!selectedCompanies) {
    return [];
  } else if (!Array.isArray(selectedCompanies)) {
    companyArray = [selectedCompanies];
  } else {
    companyArray = [...selectedCompanies];
  }

  return userCompanies.filter(o =>
    companyArray.find(o2 => o._id === (o2?.value ?? o2))
  );
};

export const getSelectedGroups = (selectedCompanies, selectedGroups) => {
  let groupArray = [];
  if (!Array.isArray(selectedGroups)) {
    groupArray = [selectedGroups];
  } else {
    groupArray = [...selectedGroups];
  }

  groupArray = groupArray.map(group => group?.value ?? group);

  const groups = [];

  if (selectedCompanies.length > 0) {
    selectedCompanies.forEach(company =>
      company.groups.forEach(group => {
        if (groupArray.indexOf(group._id) > -1) {
          groups.push(group);
        }
      })
    );
  }
  return groups;
};

export const getSelectedProjects = (selectedGroups, selectedProjects) => {
  if (!selectedProjects) {
    return null;
  }

  const projects = [];

  if (selectedGroups.length > 0) {
    selectedGroups.forEach(group =>
      group.projects.forEach(project => {
        if (selectedProjects.indexOf(project._id) > -1) {
          projects.push(project);
        }
      })
    );
  }

  return projects;
};
